import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, type Ref } from 'vue';

import { getDateKey } from './get-date-key';

import UsageTypeEmblem from './UsageTypeEmblem.vue';
import type {
  UsageDateMap,
  DayUsageInfo,
} from './LicenseUsageCalendarWidget.vue';

/**
 * `DayUsagePanel` component properties.
 */
export interface Props {
  /**
   * The date to display usage data for.
   */
  day: Date;
}


const __default__ = { name: 'DayUsagePanel' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    day: null
  },
  setup(__props: any) {

const props = __props as {
  /**
   * The date to display usage data for.
   */
  day: Date;
};



const usageDateMap = inject('usageDateMap') as UsageDateMap;
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-arguments, @typescript-eslint/no-redundant-type-constituents
const selection = inject('selectedUsageInfo') as Ref<DayUsageInfo | null>;

const dateKey = computed(() => {
  return getDateKey(props.day);
});

const dataType = computed(() => {
  const data = usageDateMap.value[dateKey.value];

  if (!data) {
    return null;
  }

  /* eslint-disable @typescript-eslint/restrict-plus-operands */

  const totalUsedLicenses =
    data.usedStudentLicenses +
    data.usedInstructorLicenses +
    data.usedAdminLicenses;

  /* eslint-enable @typescript-eslint/restrict-plus-operands */

  if (totalUsedLicenses <= 0) {
    return null;
  }

  return data.type;
});

const selected = computed(() => {
  return dateKey.value && dateKey.value === selection.value?.key;
});

const classList = computed(() => {
  const items: string[] = [];

  if (selected.value) {
    items.push('selected');
  }

  if (dataType.value) {
    items.push(dataType.value);
  } else {
    items.push('no-usage');
  }

  return items;
});

return { __sfc: true,props, usageDateMap, selection, dateKey, dataType, selected, classList, UsageTypeEmblem }
}

})